export default {"src":"/_next/static/media/main-banner-shape.b0a8249e.svg","height":55,"width":512,"blurWidth":0,"blurHeight":0};